import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Gallery from '../views/Gallery.vue'
import Adesao from '../views/Adesao.vue'
import Formandos from '../views/Formandos.vue'
import Comissao from '../views/Comissao.vue'
import Loja from '../views/Loja.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },{
    path: '/galeria',
    name: 'galeria',
    component: Gallery
  },{
    path: '/adesao',
    name: 'adesao',
    component: Adesao
  },{
    path: '/loja',
    name: 'loja',
    component: Loja
  },{
    path: '/formandos',
    name: 'formandos',
    component: Formandos
  },{
    path: '/comissao',
    name: 'comissao',
    component: Comissao
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
